import { containerKey } from '@/@core/vue-inversify-decorator';
import { Symbols } from '../../symbols';
export const DialogServiceMixin = {
    inject: [containerKey],
    methods: {
        getDialogService() {
            return this[containerKey].get(Symbols.DialogService);
        },
    },
};
